import { Button } from 'components/ui/Button'
import { Download } from 'lucide-react'
import { useCallback, useState } from 'react'
import { toast } from 'sonner'
import { downloadRecording } from 'utils/funcs/call-logs/downloadRecording'

export default function DownloadButton({ c_id }) {
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = useCallback(async () => {
    setIsDownloading(true)
    await toast.promise(downloadRecording(c_id), {
      position: 'bottom-right',
      loading: 'Downloading recording...',
      success: 'Recording downloaded successfully!',
      error: 'Error downloading recording!',
    })
    setIsDownloading(false)
  }, [c_id])

  return (
    <Button isLoading={isDownloading} variant="ghost" isIconOnly onPress={handleDownload}>
      <Download className="h-3.5 w-3.5" />
    </Button>
  )
}
